import React, { useState } from 'react';
import "../styles/StaffApply.css"; // your shared styles

const GeneralSupport = () => {
  const [formData, setFormData] = useState({
    name: '',
    discord: '',
    topic: '',
    otherTopic: '',
    message: '',
  });
  const [successMsg, setSuccessMsg] = useState('');

  const predefinedTopics = [
    "How to Join the Server",
    "How to Vote",
    "Account Issues",
    "Technical Problems",
    "Gameplay Questions",
    "Report a Player",
    "Server Performance Issues",
    "Plugin/Mod Support",
    "Rules Clarification",
    "Event Information",
    "Donations and Purchases",
    "General Feedback",
    "Other",
  ];

  const handleChange = (e) => {
    const { id, value } = e.target;
    setFormData((prev) => ({ ...prev, [id]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const webhookURL = 'https://discord.com/api/webhooks/1375120350878236742/1FPhx-qDKhJs32h69jnL2HNHZa2PM5o8FFWBN-Hn5pmav3bHV46v0relvgU1pbMomNWZ'; // Replace with your webhook

    const topicToSend =
      formData.topic === "Other" ? formData.otherTopic || "Other (No details)" : formData.topic;

    const payload = {
      username: "RixxyMC Bot",
      embeds: [
        {
          title: "🛠️ New General Support Request",
          color: 3447003, // blue
          fields: [
            { name: "👤 Minecraft Username", value: formData.name || "N/A" },
            { name: "💬 Discord Tag", value: formData.discord || "N/A" },
            { name: "📌 Topic", value: topicToSend },
            { name: "📝 Message", value: formData.message || "N/A" },
          ],
          footer: { text: "RixxyMC Support System" },
          timestamp: new Date().toISOString(),
        },
      ],
    };

    try {
      const response = await fetch(webhookURL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });

      if (response.ok) {
        setSuccessMsg("✅ Support request sent successfully!");
        setFormData({ name: '', discord: '', topic: '', otherTopic: '', message: '' });
      } else {
        setSuccessMsg("❌ Failed to send. Check webhook URL.");
      }
    } catch (err) {
      console.error(err);
      setSuccessMsg("❌ Error sending support request.");
    }
  };

  return (
    <div className="container">
      <h2>RixxyMC General Support</h2>
      <form onSubmit={handleSubmit}>
        <label htmlFor="name">Minecraft Username:</label>
        <input id="name" type="text" value={formData.name} onChange={handleChange} required />

        <label htmlFor="discord">Discord Tag (e.g. user#1234):</label>
        <input id="discord" type="text" value={formData.discord} onChange={handleChange} required />

        <label htmlFor="topic">Support Topic:</label>
        <select
          id="topic"
          value={formData.topic}
          onChange={handleChange}
          required
        >
          <option value="" disabled>
            Select a topic
          </option>
          {predefinedTopics.map((topic, idx) => (
            <option key={idx} value={topic}>
              {topic}
            </option>
          ))}
        </select>

        {formData.topic === "Other" && (
          <>
            <label htmlFor="otherTopic">Please specify:</label>
            <input
              id="otherTopic"
              type="text"
              value={formData.otherTopic}
              onChange={handleChange}
              required={formData.topic === "Other"}
            />
          </>
        )}

        <label htmlFor="message">How can we help you?</label>
        <textarea id="message" rows="4" value={formData.message} onChange={handleChange} required />

        <button type="submit">Submit Support Request</button>
        {successMsg && <div className="success">{successMsg}</div>}
      </form>
    </div>
  );
};

export default GeneralSupport;
